import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/f1-fantasy/statistics")({
  head: () => ({
    meta: [
      { title: "F1 Driver & Constructor Statistics | Toolverse" },
      {
        name: "description",
        content:
          "Comprehensive F1 driver and constructor statistics across all seasons. Race results, fantasy performance, points-per-million ratios, and multi-year data.",
      },
      {
        property: "og:title",
        content: "F1 Driver & Constructor Statistics | Toolverse",
      },
      {
        property: "og:description",
        content:
          "In-depth F1 statistics for drivers and constructors: race results, fantasy points, and performance analytics.",
      },
      {
        property: "og:url",
        content: "https://toolverse.me/f1-fantasy/statistics",
      },
    ],
    links: [],
  }),
  component: StatisticsLayout,
});

function StatisticsLayout() {
  return <Outlet />;
}
